import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { useCreatePZ } from "../../../../../components/WMS/ExReceptions/useCreatePZ"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

type Search = {
  warehouseId?: string
}

type RawSearch = {
  warehouseId?: unknown
}

export const Route = createFileRoute(
  "/_layout/WMS/documents/ex-receptions/new",
)({
  component: CreateExReceptionDraftPage,
  validateSearch: (search: RawSearch): Search => ({
    warehouseId:
      typeof search.warehouseId === "string" ? search.warehouseId : undefined,
  }),
})

function CreateExReceptionDraftPage() {
  const navigate = useNavigate()
  const { warehouseId } = Route.useSearch()
  const { createPZ, isCreating, isResolvingWarehouses, canCreate } =
    useCreatePZ()
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    startedRef.current = true
    void createPZ(warehouseId)
  }, [canCreate, createPZ, isResolvingWarehouses, warehouseId])

  const handleCancel = () =>
    navigate({
      to: warehouseId
        ? "/WMS/warehouses/$warehouse"
        : "/WMS/documents/document-list",
      ...(warehouseId
        ? { params: { warehouse: warehouseId } }
        : { search: { page: 1, page_size: 50 } }),
    } as any)

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument PZ"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu PZ..."
      idleLabel="Przygotowywanie edycji dokumentu PZ..."
    />
  )
}
